import { render, staticRenderFns } from "./IndicadoresDataTable.vue?vue&type=template&id=67f46e36&scoped=true"
import script from "./IndicadoresDataTable.vue?vue&type=script&lang=js"
export * from "./IndicadoresDataTable.vue?vue&type=script&lang=js"
import style0 from "./IndicadoresDataTable.vue?vue&type=style&index=0&id=67f46e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f46e36",
  null
  
)

export default component.exports